import React from "react";
import AnimatedCounter from "./AnimatedCounter";
export default function Stats() {
  return (
    <div className=" -mb-12">
      <section className="bg-coolGray-50 py-4">
        <div className="container px-4 mx-auto">
          <div className="flex flex-wrap justify-center -m-3">
            <div className="w-full md:w-1/2 xl:w-1/5 p-3 ">
              <div className="p-8 bg-white grid grid-cols-2 ">
                <div className="mb-4 max-w-max bg-blue-50 text-blue-600 p-3 rounded-md">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    className="w-5 h-5"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M9.674 2.075a.75.75 0 01.652 0l7.25 3.5A.75.75 0 0117 6.957V16.5h.25a.75.75 0 010 1.5H2.75a.75.75 0 010-1.5H3V6.957a.75.75 0 01-.576-1.382l7.25-3.5zM11 6a1 1 0 11-2 0 1 1 0 012 0zM7.5 9.75a.75.75 0 00-1.5 0v5.5a.75.75 0 001.5 0v-5.5zm3.25 0a.75.75 0 00-1.5 0v5.5a.75.75 0 001.5 0v-5.5zm3.25 0a.75.75 0 00-1.5 0v5.5a.75.75 0 001.5 0v-5.5z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </div>
                <div>
                  <h2 className="font-semibold text-2xl text-coolGray-900 tracking-tighter">
                  <AnimatedCounter start={0} end={3500} duration={2000} />
                  </h2>
                  <p className="text-xs font-medium text-coolGray-500">
                    Offers this Year
                  </p>
                </div>
              </div>
            </div>
            <div className="w-full md:w-1/2 xl:w-1/5 p-3">
              <div className="p-8 bg-white grid grid-cols-2">
                <div className="mb-4 max-w-max bg-blue-50 text-blue-600 p-3 rounded-md">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    className="w-5 h-5"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M2.106 6.447A2 2 0 001 8.237V16a2 2 0 002 2h14a2 2 0 002-2V8.236a2 2 0 00-1.106-1.789l-7-3.5a2 2 0 00-1.788 0l-7 3.5zm1.48 4.007a.75.75 0 00-.671 1.342l5.855 2.928a2.75 2.75 0 002.46 0l5.852-2.926a.75.75 0 10-.67-1.342l-5.853 2.926a1.25 1.25 0 01-1.118 0l-5.856-2.928z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </div>
                <div>
                  <h2 className="font-semibold text-2xl text-coolGray-900 tracking-tighter">
                    <AnimatedCounter start={0} end={515} duration={2000} />
                  </h2>
                  <p className="text-xs font-medium text-coolGray-500">
                    Request Daily
                  </p>
                </div>
              </div>
            </div>
            <div className="w-full md:w-1/2 xl:w-1/5 p-3">
              <div className="p-8 bg-white grid grid-cols-2 ">
                <div className="mb-4 max-w-max bg-blue-50 text-blue-600 p-3 rounded-md">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    className="w-5 h-5"
                  >
                    <path d="M10 9a3 3 0 100-6 3 3 0 000 6zM6 8a2 2 0 11-4 0 2 2 0 014 0zM1.49 15.326a.78.78 0 01-.358-.442 3 3 0 014.308-3.516 6.484 6.484 0 00-1.905 3.959c-.023.222-.014.442.025.654a4.97 4.97 0 01-2.07-.655zM16.44 15.98a4.97 4.97 0 002.07-.654.78.78 0 00.357-.442 3 3 0 00-4.308-3.517 6.484 6.484 0 011.907 3.96 2.32 2.32 0 01-.026.654zM18 8a2 2 0 11-4 0 2 2 0 014 0zM5.304 16.19a.844.844 0 01-.277-.71 5 5 0 019.947 0 .843.843 0 01-.277.71A6.975 6.975 0 0110 18a6.974 6.974 0 01-4.696-1.81z" />
                  </svg>
                </div>
                <div>
                  <h2 className="font-semibold text-2xl text-coolGray-900 tracking-tighter">
                    <AnimatedCounter start={0} end={1145} duration={2000} />
                  </h2>
                  <p className="text-xs font-medium text-coolGray-500">
                  Affiliates
                  </p>
                </div>
              </div>
            </div>
            <div className="w-full md:w-1/2 xl:w-1/5 p-3">
              <div className="p-8 bg-white grid grid-cols-2">
                <div className="mb-4 max-w-max bg-blue-50 text-blue-600 p-3 rounded-md">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    className="w-5 h-5"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M1 2.75A.75.75 0 011.75 2h10.5a.75.75 0 010 1.5H12v13.75a.75.75 0 01-.75.75h-1.5a.75.75 0 01-.75-.75v-2.5a.75.75 0 00-.75-.75h-2.5a.75.75 0 00-.75.75v2.5a.75.75 0 01-.75.75h-2.5a.75.75 0 010-1.5H2v-13h-.25A.75.75 0 011 2.75zM4 5.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1zM4.5 9a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zM8 5.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1zM8.5 9a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zM14.25 6a.75.75 0 00-.75.75V17a1 1 0 001 1h3.75a.75.75 0 000-1.5H18v-9h.25a.75.75 0 000-1.5h-4zm.5 3.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1zm.5 3.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </div>
                <div>
                  <h2 className="font-semibold text-2xl text-coolGray-900 tracking-tighter">
                    <AnimatedCounter start={0} end={805} duration={2000} />
                  </h2>
                  <p className="text-xs font-medium text-coolGray-500">
                    Total Resorts
                  </p>
                </div>
              </div>
            </div>
            <div className="w-full md:w-1/2 xl:w-1/5 p-3">
              <div className="p-8 bg-white  grid grid-cols-2">
                <div className="mb-4 max-w-max bg-blue-50 text-blue-600 p-3 rounded-md">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    className="w-5 h-5"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M1 2.75A.75.75 0 011.75 2h16.5a.75.75 0 010 1.5H18v8.75A2.75 2.75 0 0115.25 15h-1.072l.798 3.06a.75.75 0 01-1.452.38L13.41 18H6.59l-.114.44a.75.75 0 01-1.452-.38L5.823 15H4.75A2.75 2.75 0 012 12.25V3.5h-.25A.75.75 0 011 2.75zM7.373 15l-.391 1.5h6.037l-.392-1.5H7.373zm7.49-8.931a.75.75 0 01-.175 1.046 19.326 19.326 0 00-3.398 3.098.75.75 0 01-1.097.04L8.5 8.561l-2.22 2.22A.75.75 0 115.22 9.72l2.75-2.75a.75.75 0 011.06 0l1.664 1.663a20.786 20.786 0 013.122-2.74.75.75 0 011.046.176z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </div>
                <div>
                  <h2 className="text-4xl font-bold text-blue-500">
                  <AnimatedCounter start={0} end={120} duration={2000} />
                  </h2>
                  <p className="text-xs font-medium text-coolGray-500">
                    Annual Events
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
